import * as types from "@/store/constants/types";
export default {
  [types.CHNAGE_CASINO_TIPS_STATE](state: any, payLoad: any) {
    state.tipsObj = payLoad;
    console.log(state.tipsObj)
  },
};
